import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Table, TableBody, TableSortLabel, Paper, Button, TableRow, TableHead, TableCell, Checkbox, Grid, Box } from "@mui/material";
import LeaseList from "../components/LeaseList";
import { Pagination, PageLoader, DeletePopUp, STableLoader, FilterComponent, jetStreamInstance } from "../../../shared_elements";
import { bulkExportLeaseApi, deleteLeaseApi, getAssetListApi, getLeasesApi } from "../apiServices";
import { checkApiStatus } from "../../../utils";
import LeaseCRU from "../components/LeaseCRU";
import LeaseChangeStatus from "../components/LeaseChangeStatus";
import NoRecordFound from "../../../shared_elements/NoRecordFound";
import { globalDeleteService, globalGetService, globalPostService } from "../../../utils/globalApiServices";
import { useSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../shared_elements/components";
import { leaseOptionObj } from "../components/LeaseConstants";
import { setFileUploadDetails, setLeaseBasicDetails } from "../../../shared_elements/actions";
import { getLesseeApi, getOwnerListApi, getOwnerLessorApi } from "../../../shared_elements/actionCreators";
import { useDispatch, useSelector } from "react-redux";
import RevisionHistory from "../../../shared_elements/components/RevisionHistory";
import FileUploadLayout from "../../../shared_elements/components/FileUploadLayout";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../shared_elements/components/ModuleWiseRevisionHistory";
import fileUpload, { getApiResponse } from "../../../utils/fileUpload";
import { RoleBaseAccess } from "../../../hoc";
import { PermissionWrapper } from "../../../wrappers";
import DeploymentBannerWithOffset from "../../../shared_elements/components/DeploymentBannerWithOffSet";
import { ASSET_TYPE_OPTIONS } from "../../../constants";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const leaseStatusOptions = [
  { label: 'Draft', value: 'Draft'},
  { label: 'Active', value:'Active'},
  { label: 'Closed', value: 'Closed' },
  { label: 'On-hold', value:'On-hold'},
  { label: 'Terminated', value:'Terminated'},
];

const leaseTypeOptions = [
  { label: 'Operating Lease', value: 3 },
  { label: 'Finance Lease', value: 4 },
  { label: 'Wet Lease', value: 2 },
  { label: 'Dry Lease', value: 1 },
];

const LeasesHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Leases`, page_type: page_type, })
  }
  const tableSorting = (key, name, disableSort = false) => (
    <TableSortLabel
      disabled={disableSort}
      hideSortIcon={disableSort}
      sx={{ whiteSpace: "nowrap" }}
      active={sortInfo.sort_by === key}
      direction={sortInfo.sort_by === key ? (sortInfo.sort || "asc").toLowerCase() : "asc"}
      onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
    >
      {name}
    </TableSortLabel>
  );

  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap"}}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease", operationType: ['R'] }}>
          <Checkbox
            color="primary"
            size="small"
            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
            checked={item?.length === bulk?.ids?.length && item?.length > 0}
          /></PermissionWrapper> Action(s) </TableCell>
        <TableCell>{tableSorting("status", "Status")}</TableCell>
        <TableCell>{tableSorting("reference_code", "Ref Code", true)}</TableCell>
        <TableCell>{tableSorting("assigned_code", "Assigned Code")}</TableCell>
        <TableCell>{tableSorting("asset", "Asset", true)}</TableCell>
        <TableCell>{tableSorting("lessor", `Lessor/Holdco`, true)}</TableCell>
        <TableCell>{tableSorting("owner", `Owner/SPV`, true)}</TableCell>
        <TableCell>{tableSorting("lessee", "Lessee", true)}</TableCell>
        <TableCell>{tableSorting("lease_type", "Lease Type")}</TableCell>
        <TableCell>{tableSorting("lease_duration", "Duration")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

const Leases = () => {
  const { fileUploadDetails, lessee, lessor, owner } = useSelector((state) => state.leases);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [changeStatusLeases, setChangeStatusLeases] = useState({ mode: '', modal: false, data: null })
  const [leasesInfo, setLeasesInfo] = useState({ list: [], pagination: {} });
  const [addEditLeases, setAddEditLeases] = useState({ mode: '', modal: false, data: null });
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [deleteLeases, setDeleteLeases] = useState({ modal: false, data: null, })
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [filter, setFilter] = useState({});
  const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
  const { enqueueSnackbar } = useSnackbar();
  const[isExport,seIsExport]=useState(false)
  const [isBulkExporting, setIsBulkExporting] = useState(false);
  const[uploadFileProgressData,setUploadFileProgressData]=useState({})
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug,setSlug]=useState({})
  const [assetList, setAssetList] = useState([]);

  const leaseFilterMenu = {
    asset_type:{title: 'Asset Type', inputType: 'dropdown', options: ASSET_TYPE_OPTIONS || [], valueKey: 'value', labelKey: 'label', multiple: true },
    reference_code: { title: 'Ref Code', inputType: 'text' },
    assigned_code: { title: 'Assigned Code', inputType: 'text' },
    status: { title: 'Status', inputType: 'dropdown', options: leaseStatusOptions, valueKey: 'value', labelKey: 'label', multiple: false },
    lease_type: { title: 'Lease Type', inputType: 'dropdown', options: leaseTypeOptions, valueKey: 'value', labelKey: 'label', multiple: false },
    asset_id: { title: 'Asset', inputType: 'dropdown', options: assetList || [], valueKey: 'unique_key', labelKey: 'name', multiple: true, renderOption: (props, option) => ( <Box component="li" {...props} key={option.slug || option.unique_key}> {option.name} </Box>) },
    lessor_name_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
    owner_id: { title: 'Owner/SPV', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
    lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: false },
    start_date: { title: 'Lease Start', inputType: 'date' },
    end_date: { title: 'Lease End', inputType: 'date' },
  };

  useEffect(() => {
    const uploadedFileData = getApiResponse("lease", slug);
    getLeasesList('skeletonLoader', { per_page: 50 });
    getAssetList();
    if (!lessee?.length) dispatch(getLesseeApi());
    if (!lessor?.length) dispatch(getOwnerLessorApi());
    if (!owner?.length) dispatch(getOwnerListApi());
    trackActivity('Page Viewed', { page_title: 'Leases' })
        setUploadFileProgressData({uploadedFileData});
  }, []);

  const getLeasesList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    const apiQuery = { ...query };
    if (apiQuery.asset_id) {
      apiQuery.asset_id = apiQuery.asset_id.split(',').map(key => { const [id, assetType] = key.split('_'); return `(${id},${assetType})`; });
    }
    globalGetService(getLeasesApi(params, apiQuery))
      .then(response => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        setLeasesInfo(response?.data?.data);
      })
      dispatch(setFileUploadDetails({}))
  }
  const onDeleteLease = () => {
    setLoading(true);
    const draftBulkIds = (bulk?.ids || []).filter(item => item?.status === 'Draft');
    globalDeleteService(deleteLeaseApi(),
      { ids:deleteLeases?.data?.id?[deleteLeases?.data?.id]: bulk?.type === 'bulk' || bulk?.type === 'single' ? draftBulkIds.map(item => item?.id) : [] }
    )
      .then(response => {
        if (checkApiStatus(response)) {
          trackActivity('Item Deleted', { page_title: `Delete Lease`, success_msg: response?.data?.message, item_ids: deleteLeases?.data || draftBulkIds, response: response?.data })
          setDeleteLeases({ modal: false, data: null });
          setLoading(false);
          getLeasesList('fetch', { per_page: leasesInfo?.pagination?.per_page });
          setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Lease`, error_msg: response?.data?.message, item_ids: deleteLeases?.data || draftBulkIds, response: response?.data })
        }
      })
  }
  const onDeteAttchments = (deltedslug) => {
    setAttachments({
      ...attachments, data: {
        ...attachments.data,
        attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
      }
    });
    if (addEditLeases?.modal) {
      setAddEditLeases({
        ...addEditLeases,
        data: {
          ...addEditLeases.data,
          attachments: addEditLeases.data.attachments.filter(item => item?.slug !== deltedslug)
        }
      })
    }
    getLeasesList('', { per_page: leasesInfo?.pagination?.per_page });
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const onApplyFilter = (query) => {
    setFilter(query);
    getLeasesList('', { ...query, page: 1, per_page: leasesInfo?.pagination?.per_page || 50 });
  };

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getLeasesList('', { ...filter, ...sortQuery, per_page: leasesInfo?.pagination?.per_page });
  }


 const handleUpload = async (slug, mode) => {
    setSlug({slug:slug})
    await fileUpload({
   attachments: fileUploadDetails.attachments,
   module_name: "lease",
   slug: slug,
   query: { section_type: 'headlines-attachments', record_action_type: mode },
   onStart: () => setLoading(true),
   onComplete: () => setLoading(false),
   onProgress: ({ progressRefs, attachments, response }) => {
    setUploadFileProgressData({ progressRefs, attachments ,response});
   },
   onSuccess: (success_msg) => {
    enqueueSnackbar(success_msg, { variant: "success" });
    getLeasesList("", { per_page: 50 });
   },
   onError: (err) => {
    enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error" });
   }
   });
   setSlug({})
  };

  const getAssetList = () => {
    globalGetService(getAssetListApi({ is_invoice: true })).then(response => {
      if (checkApiStatus(response)) {
        const formatted = (response?.data?.data || []).map(item => ({
                ...item,
                unique_key: `${item.id}_${item.asset_type}`,
            }));
        setAssetList(formatted);
      }
    });
  };

  const handleExport = () => {
    let query = { ...filter, export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
    seIsExport(true);
    globalGetService(getLeasesApi(params, query)).then((response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(
          response?.data.message,
          { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
        );
        seIsExport(false);
      }
    })
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Leases`, page_type: page_type, })
  }
  const draftBulkIds = (bulk?.ids || []).filter(item => item?.status === 'Draft');

  const handleBulkExport = () => {
    setIsBulkExporting(true);
    const lease_slugs = (bulk?.ids || []).map(item => item?.slug);
    globalPostService(bulkExportLeaseApi(), { lease_slugs })
      .then(response => {
        setIsBulkExporting(false);
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
          trackActivity('Item Exported', { page_title: `Bulk Export Lease`, success_msg: response?.data?.message, item_ids: bulk?.ids, response: response?.data })
          setBulk({ modal: false, ids: [], title: '', type: '' });
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
          trackActivity('Item Exported', { page_title: `Bulk Export Lease`, error_msg: response?.data?.message, item_ids: bulk?.ids, response: response?.data })
        }
      })
  }

  return (
    <section className="active-asset-section">
      <DeploymentBannerWithOffset>
        {(bannerHeight) => (
      <div>
        <Paper elevation={0} className="lease-module-paper" sx={{ padding: '5px', marginBottom: '2px' }}>
          <Grid container spacing={1} sx={{ justifyContent: 'space-between', alignItems: 'center', placeItems:'flex-start' }}>
            <Grid size='grow' sx={{ minWidth: 0 }}>
              <Box display="flex" alignItems="center"  gap={1} flexShrink={0} sx={{marginTop:'2px' }}>
              {!skeletonLoader ? <FilterComponent filter={filter} filterMenu={leaseFilterMenu} getResponseBack={onApplyFilter} /> : null}
              </Box>
            </Grid>
            <Grid md={8} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', margin: 0, float: 'right', display: 'flex', alignItems: 'center', gap: '5px' }}>
            <li className="lease-mobile-button revision-history" style={{ display: 'flex', alignItems: 'center', transform: 'translateY(-5px)' }}><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
            {
              bulk?.type && bulk?.ids?.length ?
                <>
                  <li className="lease-mobile-button">
                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                  </li>
                  <li className="lease-mobile-button">
                    <Button startIcon={isBulkExporting ? <ButtonLoader size={15} /> : null} disabled={isBulkExporting} onClick={() => { handleBulkExport(); handleItemClicked('Bulk Export Button') }} variant="outlined" size="small" className='btn-primary' color='primary'>{`Lease Summary Bulk Export (${bulk?.ids?.length})`}</Button>
                  </li>
                  {
                    draftBulkIds.length > 0 ?
                      <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease_details", operationType: ['D'] }}>
                        <li className="lease-mobile-button">
                          <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" className='btn-primary' color='error'>{`Delete (${draftBulkIds.length})`}</Button>
                        </li>
                      </PermissionWrapper> : null
                  }
                </> : null
            }
            {leasesInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' className='btn-primary action-btn-start-icon' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease_details", operationType: ['C'] }}>
              <li className="lease-mobile-button"> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setAddEditLeases({ modal: true, data: leaseOptionObj, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Lease </Button> </li>
            </PermissionWrapper>
          </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className="active-asset-list lease-module-paper" elevation={0}>
          {
            skeletonLoader ? <STableLoader count={6} rowCount={13} /> : <>
              <div style={{ ...(leasesInfo?.list?.length > 0 ? { height: `${window.innerHeight - 175 - bannerHeight}px`, maxHeight: 'none' } : { height: 'auto', maxHeight: `${window.innerHeight - 175 - bannerHeight}px` }), overflow: "auto", paddingBottom: '10px', boxSizing: 'border-box' }}>
                <Table className="mui-table-format" stickyHeader>
                  <LeasesHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={leasesInfo?.list} toggleBulkOps={toggleBulkOps} />
                  <TableBody>
                    {leasesInfo?.list?.length > 0 && leasesInfo?.list?.map((item, index) => {
                      const updatedItem = { ...item, asset: { ...item.asset, asset_type: item?.asset_type }, lessor: { ...item?.lessor_detail }, lease_duration_type: { label: '', value: item?.lease_duration_type } }
                      const uploadedFileData = getApiResponse("lease", item?.slug);

                      return (
                        <LeaseList
                          slug={slug?.slug}
                          uploadFileProgressData={uploadFileProgressData}
                          onView={() => { dispatch(setLeaseBasicDetails(updatedItem)); navigate(`/lease/${item?.slug}/lease-details/headlines`, { state: { asset: item?.asset} }); }}
                          statusChange={() => setChangeStatusLeases({ modal: true, data: { status: item?.status, reason: item?.reason, closure_date: item?.closure_date, id: item?.id, asset_slug: item?.asset_slug, asset_type: item?.asset_type, leaseSlug: item?.slug, lessor_id: item?.lessor, lease: item?.lease_id }, mode: "add" })}
                          key={index}
                          item={item}
                          uploadedFileData={uploadedFileData }
                          bulk={bulk}
                          viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                          viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                          onEditFn={() => setAddEditLeases({ modal: true, data: item, mode: 'edit' })}
                          onDeleteEolFn={() => setDeleteLeases({ modal: true, data: item, })}
                          toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
                {leasesInfo?.list?.length === 0 ? <NoRecordFound /> : null}
              </div>
              <Paper>
              <Pagination
                pagination={leasesInfo?.pagination}
                onPageChange={(event, newPage) => { const pageNum = newPage + 1; getLeasesList('pageLoader', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: pageNum, per_page: leasesInfo.pagination.per_page, }); }}
                onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getLeasesList('pageLoader', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: 1, per_page: perPage, }); }}
              />
              </Paper>
            </>
          }
        </Paper>
        {
          attachments.modal ? 
            <ShowAttachments
            url='delete-attachment'
            moduleName={"Lease"}
            deleteQuery={{ section_type: 'headlines-attachments' }}
            attachmentsData={attachments}
            getResponseBack={onDeteAttchments}
            toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
            onViewDisabled={attachments?.mode==='view'}
            permissionKey='lease_details'
          /> : null
        }
        {
          addEditLeases?.modal ?
            <LeaseCRU
            fileUpload={handleUpload}
              modeType={addEditLeases.modal}
              leasesInfo={leasesInfo}
              addEditLeases={addEditLeases}
              onOpenAttachments={() => setAttachments({ modal: true, data: addEditLeases?.data, mode:'view' })}
              getResponseBack={() => getLeasesList('fetch', { per_page: leasesInfo.pagination.per_page })}
              onToggleModal={() => setAddEditLeases({ modal: false, mode: '', data: null })}
            /> : null
        }
        {deleteLeases?.modal ?
          <DeletePopUp
            modal={deleteLeases?.modal}
            title="Delete Lease"
            content={`Are you sure you want to delete?`}
            onToggleModal={() => setDeleteLeases({ modal: false, ids: [] })}
            onDeleteRecords={() => onDeleteLease("single")}
          /> : null
        }

        {bulk.modal ?
          <DeletePopUp
            modal={bulk.modal}
            title="Delete All Lease"
            onDeleteRecords={() => onDeleteLease("bulk")}
            content={`Are you sure you want to delete the ${draftBulkIds.length} selected lease${draftBulkIds.length > 1 ? 's' : ''} ?`}
            onToggleModal={() => setBulk({ ...bulk, modal: false })}
          /> : null
        }
        {
          changeStatusLeases?.modal &&
          <LeaseChangeStatus
            params={params}
            getList={() => getLeasesList('fetch', { per_page: leasesInfo.pagination.per_page })}
            changeStatusLeases={changeStatusLeases}
            setChangeStatusLeases={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })}
            onToggleModal={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })} />
        }
        {
          revisionHistory.modal &&  
          <RevisionHistory 
           moduleName={"lease"}
           revisionHistory={revisionHistory}
           onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
        }
          <FileUploadLayout
             uploadFileStatus={uploadFileStatus}
             open={uploadFileStatus?.modal}
             setUploadFileStatus={setUploadFileStatus}
             uploadFileProgressData={uploadFileProgressData}
             progressRefs={uploadFileProgressData?.progressRefs}
             attachments={uploadFileProgressData?.attachments}
             onDownloadComplete={()=> setSlug({})}
          />
     
      </div>
        )}
      </DeploymentBannerWithOffset>
      {isLoading ? <PageLoader /> : null}
    </section>
  );
};
export default RoleBaseAccess(Leases, { application: 'lease_revamp', feature: 'lease_details', operationType: ['R'] });
